import script from "./ActionButton.vue?vue&type=script&lang=js&setup=true"
export * from "./ActionButton.vue?vue&type=script&lang=js&setup=true"

import "./ActionButton.vue?vue&type=style&index=0&id=2a9dede8&lang=css"

const __exports__ = script;

export default __exports__